import React from "react";
import { BrowserRouter, Switch, Redirect } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { workspaceSlug } from "../config";
import LoggedInLayout from "../layout";
import Kanban from "../pages/Kanban";
import FlowEditor from "../pages/Chatbot/FlowEditor";
import Chatbot from "../pages/Chatbot";
import Dashboard from "../pages/Dashboard/";
import Tickets from "../pages/Tickets/";
import RplChat from "../pages/RplChat";
import SaasPortal from "../pages/Saas";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import Settings from "../pages/Settings/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";

import Route from "./Route";

const Routes = () => {
  return (
    <BrowserRouter basename={workspaceSlug() ? "/app/" + workspaceSlug() : "/"}>
      <AuthProvider>
        
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <Route exact path="/assinatura" component={SaasPortal} />
            <WhatsAppsProvider>
              <LoggedInLayout>
                <Route exact path="/" component={Dashboard} isPrivate />
                <Route exact path="/tickets/:ticketId?" component={Tickets} isPrivate />
                <Route exact path="/email-accounts" component={() => <Redirect to="/settings/email" />} isPrivate />
                <Route exact path="/connections" component={() => <Redirect to="/settings/connections" />} isPrivate />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route exact path="/kanban" component={Kanban} isPrivate />
                <Route exact path="/rpl-chat" component={RplChat} isPrivate />
                <Route exact path="/platform" component={() => <Redirect to="/settings/saas" />} isPrivate />
                <Route exact path="/chatbot" component={FlowEditor} isPrivate />
                <Route exact path="/chatbot/menu" component={Chatbot} isPrivate />
                <Route exact path="/users" component={Users} isPrivate />
                <Route exact path="/quickAnswers" component={QuickAnswers} isPrivate />
                <Route exact path="/settings/:section?" component={Settings} isPrivate />
                <Route exact path="/Queues" component={Queues} isPrivate />
              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer autoClose={3000} />
        
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;

